import { render, staticRenderFns } from "./RESUGDPS.vue?vue&type=template&id=871ba9d0&"
import script from "./RESUGDPS.vue?vue&type=script&lang=js&"
export * from "./RESUGDPS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('871ba9d0')) {
      api.createRecord('871ba9d0', component.options)
    } else {
      api.reload('871ba9d0', component.options)
    }
    module.hot.accept("./RESUGDPS.vue?vue&type=template&id=871ba9d0&", function () {
      api.rerender('871ba9d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/customDocuments/vistas/empresas/72235100-2/RESUGDPS.vue"
export default component.exports